import React from 'react';
import { withRouter } from 'react-router-dom';
import Aux from '../../hoc/ReactAux';

const layout = props => (
  <Aux>
    <main>{props.children}</main>
  </Aux>
);

export default withRouter(layout);

// todo: create a layout2.js that has the toolbar, etc in it.
// given this is a hack to get the delaer thanks page working



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js